/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DayFromJSON, DayToJSON, TimeRangeFromJSON, TimeRangeToJSON, } from './';
export function DaySlotFromJSON(json) {
    return DaySlotFromJSONTyped(json, false);
}
export function DaySlotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'day': DayFromJSON(json['day']),
        'timeEntries': (json['timeEntries'].map(TimeRangeFromJSON)),
    };
}
export function DaySlotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'day': DayToJSON(value.day),
        'timeEntries': (value.timeEntries.map(TimeRangeToJSON)),
    };
}
